import React, { Component } from "react";
import Constants from "Helpers/Constants";
import axios from "axios";
import init from "Helpers/WindowToken";
import { Link, Navigate } from "react-router-dom";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

import { Grid, TextField } from "@mui/material";

const fd = new FormData();

export default class AddBanner extends Component {
  state = {
    message: "",
    notification: false,
    loading: false,
    redirect: false,

    banner_title: "",
    redirect_url: "",
    banner_image: null,
  };

  componentDidMount() {}

  handleInput = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleFile = (e) => {
    const file = e.target.files[0];
    this.setState({ banner_image: file });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    if (!this.state.banner_image) {
      this.setState({
        notification: true,
        message: "Banner image is required",
      });
      setTimeout(() => this.setState({ notification: false, message: "" }), 3000);
      return;
    }

    this.setState({ loading: true });

    // prepare multipart form data
    fd.append("banner_title", this.state.banner_title);
    fd.append("redirect_url", this.state.redirect_url);
    fd.append("banner_image", this.state.banner_image);

    if (init() === "success") {
      axios
        .post(Constants.postUrls.addBanner, fd)
        .then((resp) => {
          try {
            fd.delete("banner_title");
            fd.delete("redirect_url");
            fd.delete("banner_image");
          } catch {}

          this.setState({
            loading: false,
            notification: true,
            message: "Banner added!",
            redirect: true,
          });

          setTimeout(() => {
            this.setState({ notification: false, message: "" });
          }, 2500);
        })
        .catch((err) => {
          const msg = err?.response?.data?.message || err.message || "Something went wrong";
          this.setState({
            loading: false,
            notification: true,
            message: msg,
          });
          setTimeout(() => this.setState({ notification: false, message: "" }), 5000);
        });
    } else {
      this.setState({
        loading: false,
        notification: true,
        message: "Auth token missing or invalid",
      });
      setTimeout(() => this.setState({ notification: false, message: "" }), 3000);
    }
  };

  render() {
    if (this.state.redirect === true) {
      return <Navigate to="/banner" />;
    }

    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={6} pb={3}>
          <MDBox
            mx={2}
            mt={-3}
            py={3}
            px={2}
            variant="gradient"
            bgColor="info"
            borderRadius="lg"
            coloredShadow="info"
          >
            <MDTypography variant="h6" color="white">
              Add Banner
            </MDTypography>
          </MDBox>

          <MDBox py={3} px={2}>
            <form onSubmit={this.handleSubmit}>
              <Grid container spacing={2}>
                <Grid item sm={6}>
                  <TextField
                    type="text"
                    label="Banner Title"
                    name="banner_title"
                    onChange={this.handleInput}
                    value={this.state.banner_title}
                    style={{ width: "100%" }}
                  />
                </Grid>

                <Grid item sm={6}>
                  <TextField
                    type="text"
                    label="Redirect URL"
                    name="redirect_url"
                    onChange={this.handleInput}
                    value={this.state.redirect_url}
                    style={{ width: "100%" }}
                  />
                </Grid>

                <Grid item sm={6}>
                  <TextField
                    type="file"
                    label="Banner Image"
                    name="banner_image"
                    onChange={this.handleFile}
                    InputLabelProps={{ shrink: true }}
                    style={{ width: "100%" }}
                  />
                </Grid>

                <Grid item sm={12}>
                  <MDButton variant="contained" size="small" color="info" type="submit">
                    {this.state.loading ? "Creating..." : "Create Banner"}
                  </MDButton>
                </Grid>
              </Grid>
            </form>
          </MDBox>

          <MDSnackbar
            color="success"
            icon="notifications"
            title="VASA | Banners"
            content={this.state.message}
            dateTime="Just now"
            open={this.state.notification}
          />
        </MDBox>
      </DashboardLayout>
    );
  }
}
